import PageLayout from "../../components/common/page-layout";
import Edi from "../../components/edi";
import { RequireAuth } from "../../hooks/use-auth";

/** Route page for sending and inspecting EDI transactions. */
const EdiPage = () => {
  return (
    <RequireAuth>
      <PageLayout maxWidth={false} title="EDI">
        <Edi />
      </PageLayout>
    </RequireAuth>
  );
};

export default EdiPage;
